import React from 'react';
import Modal from '@omilia/modal';

// @ts-ignore
import messages from 'constants/messages';
import ModalButtons from 'components/ModalButtons';
import { SContainer } from '../styled';

type Props = {
  onCancel: () => void;
  onUpdateFromParent: () => void;
};

const UpdateRequiredModal = ({ onCancel, onUpdateFromParent }: Props) => (
  <Modal
    open
    data-test="version-control-modal"
    glyph="notification-warning"
    hasBackdrop={false}
    title={messages.VERSION_CONTROL.MERGE_MODAL.UPDATE_PARENT_REQUIRED}
    variant="danger"
  >
    <SContainer>
      {messages.VERSION_CONTROL.MERGE_MODAL.UPDATE_PARENT_NEEDED}
      <ModalButtons
        primary={{
          text: 'Update from Parent',
          onClick: onUpdateFromParent,
          type: 'button',
        }}
        secondary={{ text: 'Cancel', onClick: onCancel }}
      />
    </SContainer>
  </Modal>
);

export default UpdateRequiredModal;
